<template>
  <div :ref="chartRefId" :style="{ width: '100%', height: '400px' }"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'GenericLineChart',

  props: {
    config: {
      type: Object,
      required: true
    },

    data: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      chartRefId: `chart-${this._uid}`,
      chartInstance: null
    };
  },

  mounted() {
    this.initChart();
    window.addEventListener('resize', this.resizeChart);
  },

  watch: {
    config: {
      deep: true,
      handler() {
        this.updateChart();
      }
    },

    data: {
      deep: true,
      handler() {
        this.updateChart();
      }
    }
  },

  methods: {
    initChart() {
      const chartEl = this.$refs[this.chartRefId];
      if (!chartEl) return;

      this.chartInstance = echarts.init(chartEl);

      this.updateChart();
    },

    buildOption() {
      const xField = this.config.xAxis.field;
      const yField = this.config.yAxis.field;

      return {
        title: {
          text: this.config.title || '',
          left: 'center'
        },

        tooltip: {
          trigger: 'axis'
        },

        legend: this.config.showLegend
          ? {}
          : undefined,

        xAxis: {
          type: this.config.xAxis.type,
          data: this.data.map(row => row[xField])
        },

        yAxis: {
          type: this.config.yAxis.type
        },

        series: [
          {
            name: this.config.yAxis.label || 'Value',
            type: 'line',
            data: this.data.map(row => row[yField]),

            lineStyle: {
              color: this.config.colors && this.config.colors.length
                ? this.config.colors[0]
                : undefined
            },

            itemStyle: {
              color: "#FFD38A"
            }
          }
        ]
      };
    },

    updateChart() {
      if (!this.chartInstance) return;

      this.chartInstance.setOption(
        this.buildOption(),
        true
      );
    },

    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },

    getChartInstance() {
      return this.chartInstance;
    }
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.resizeChart);

    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
};
</script>